<!--周转补货单列表-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container order-query">
      <el-form size="small" :inline="true" :model="listQuery">
        <!--     单据编号   -->
        <el-form-item size="mini" :label="$t('stStockAlter.receiptNO')">
          <el-input v-model.trim="listQuery.provideno" clearable :placeholder="$t('')" />
        </el-form-item>
        <!--          搜索-->
        <el-button size="mini" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
      </el-form>
      <el-table
          :key="tableKey"
          height="500"
          v-loading="listLoading"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          style="width: 100%;"
    >
      <!-- 操作 -->
      <el-table-column :label="$t('sysOperationLog.moduleName')" width="100" align="center">
        <template v-slot="{row}">
          <!-- 查看 -->
          <el-button
            circle
            type="primary"
            size="mini"
            icon="el-icon-search"
            :title="$t('function.menu.view')"
            @click="handleView(row)"
          />
          <!-- 支付 -->
          <el-button
              v-if="row.status == 0"
            circle
            size="mini"
            type="success"
            icon="el-icon-goods"
            :title="$t('Common.pay')"
            @click="handleUpdate(row)"
          />
          <!-- v-if="listQuery.status == 1 && listQuery.sendStatus == 1 && listQuery.recStatus == 1"  -->
          <!-- 收货 -->
          <el-button
            v-if="row.status == 1 && row.sendFlag == 1 && row.recStatus == 0"
            circle
            size="mini"
            type="success"
            icon="el-icon-check"
            :title="$t('lm.goods.receipt')"
            @click="handleReceiving(row)"
          />
        </template>
      </el-table-column>
      <!--      代办处编号-->
      <el-table-column :label="$t('miAgent.agentNo.id')" prop="agentNo" align="center" />
      <!--      公司编号-->
      <el-table-column :label="$t('pmProductSppm.company')" prop="companycode" align="center" />
      <!--      单据编号-->
      <el-table-column :label="$t('poOrderAgent.provideno')" prop="provideno" align="center" />
      <!--      单据类型-->
      <el-table-column :label="$t('fiAcInput.orderType')" align="center">
        <template v-slot="{row}">
           {{$lt(initDict.orderType,row.providetype)}}
        </template>
      </el-table-column>
      <!--      创建人-->
      <el-table-column :label="$t('pmProductSppm.createUser')" prop="creatorCode" align="center" />
      <!--      创建时间-->
      <el-table-column :label="$t('pmProductSppm.createDate')" prop="createTime" align="center" />
      <!--      单据状态-->
      <el-table-column :label="$t('pdRetManifest.receiptStatus')" align="center">
        <template v-slot="{row}">
          {{$lt(initDict.status,row.status)}}
        </template>
      </el-table-column>
      <!--      审核人-->
      <el-table-column :label="$t('poLpOrder.checkUser')" prop="checkCode" align="center" />
      <!--      审核时间-->
      <el-table-column :label="$t('pmProductSppm.checkDate')" prop="checkTime" align="center" />
      <!--      备注-->
      <el-table-column :label="$t('poReturn.createRemark')" prop="remark" align="center" />
      <!--      收货人地址-->
      <el-table-column :label="$t('pdSendInfo.recipientAddr')" prop="recAddr" align="center" />
      <!--      收货人姓名-->
      <el-table-column :label="$t('pdSendInfo.recipientName')" prop="recName" align="center" />
      <!--      联系电话-->
      <el-table-column :label="$t('sysCompany.phone')" prop="recPhone" align="center" />
      <!--      发货人-->
      <el-table-column :label="$t('pd.sender')" prop="sendCode" align="center" />
      <!--      发货时间-->
      <el-table-column :label="$t('order.shippment.sidate')" prop="sendTime" align="center" />
      <!--      发货状态-->
      <el-table-column :label="$t('ai.sendinfo')" align="center">
        <template v-slot="{row}">
          {{$lt(initDict.sendStatus,row.sendStatus)}}
        </template>
      </el-table-column>
      <!--      收货状态-->
      <el-table-column :label="$t('pd.recStatus')" align="center">
        <template v-slot="{row}">
          {{$lt(initDict.recStatus,row.recStatus)}}
        </template>
      </el-table-column>
      <!--      取消人编号-->
      <el-table-column :label="$t('bdAdjustPv.cancelCode')" prop="cancelCode" align="center" />
      <!--      取消时间-->
      <el-table-column :label="$t('common.cancelTime')" prop="cancelTime" align="center" />
      </el-table>
      <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          >
        <el-form size="small" :inline="true" :model="listQuery2">
        <!--     支付密码   -->
        <el-form-item size="mini" :label="$t('Common.pay.password')">
          <el-input type="password" v-model.trim="listQuery2.payPassword" clearable :placeholder="$t('')" />
        </el-form-item>
        <el-button type="primary" size="mini"  @click="btnPay">{{ $t('button.confirm')}}</el-button>
      </el-form>
        <span slot="footer" class="dialog-footer">
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// poOrderAgentPay
import {poOrderAgents, poOrderAgentPay, poOrderAgentRec} from "@/api/agent";
export default {
  name: "TurnoverOrderList",
  data(){
    return{
      dialogVisible: false,
      sjopen:false,
      tableLoading: false,
      listLoading: false,
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        companyCode: null
      },
      listQuery2: {
        payPassword: ''
      },
      tableKey: 0,
      list: [],
      total: 0,
      canUseF$:0,
      totalAmount:0,
      wWeekList:null,
      companyCodelist: null,
      dcNoBuledialong:true,
      activeName:'first',
      initDict:{
        orderType:'po.order.agentstatus',
        status: 'po.agengtorder.astatus',
        sendStatus: 'sysaftersale.sendflag',
        recStatus: 'pd.recstatus'
      }
    }
  },
  mounted() {
    this.wWeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
    this.getList()
  },
  methods:{
    //  搜索
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList(){
      this.listLoading = true
      poOrderAgents({...this.listQuery}).then(res=>{
        this.list = res.data.records
        this.listLoading = false
      }).catch(err=>{
        console.error(err)
      })
    },
    handleView(row){
      this.$router.push({name: 'TurnoverOrderView', params:{ id: row.id } })
    },
    handleUpdate(row){
      this.dialogVisible = true
      this.listQuery2 = {}
      this.listQuery2.id= row.id
    },
    btnPay(){
      if (this.listQuery2.payPassword== '') {
          this.$message.error(this.$t('please.input.your.pay.password'));
        }
        this.btnloading = true
        poOrderAgentPay({...this.listQuery2}).then(() => {
          this.btnloading = false
          this.getList()
          this.dialogVisible = false
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        }).catch(err => {
          this.btnloading = false
          this.dialogVisible = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
    },
    handleReceiving(row) {
      this.$confirm(this.$t('fi.sure.handle'), this.$t('common.tips'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('operation.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.btnloading = true
        poOrderAgentRec({'id': row.id}).then(() => {
          this.btnloading = false
          this.getList()
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        }).catch(err => {
          this.btnloading = false
          this.dialogVisible = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('operation.button.cancel')
        })
        this.btnloading = false
      })
    },
  }
}
</script>

<style scoped>

</style>
